export const redirectComponent = {
  'Importacion': {
    'Confronta': {
      'check_in_vuelos': {
        'activo': 'importación/confronta/check_in_vuelos'
      }
    },
    'entradas': {
      'registro_vuelos': {
        'activo': 'importación/entradas/registro_vuelo',
      },
      'arribos': {
        'activo': 'importación/entradas/arribos',
      },
      'alta_manifiesto': {
        'activo': 'importación/entradas/alta_manifiesto',
      },
      'alta_master': {
        'activo': 'importación/entradas/alta_master',
      },
      'alta_inventario': {
        'activo': 'importación/entradas/alta_inventario',
      }
    },
    'mostrador': {
      'pre-facturación': {
        'activo': 'importación/mostrador/pre-facturación',
      },
      'cobro_en_caja': {
        'activo': 'importación/mostrador/cobro_en_caja',
      },
      'facturación_múltiple': {
        'activo': 'importación/mostrador/facturación_múltiple',
      },
      'facturas': {
        'activo': 'importación/mostrador/facturas',
      }
    },
    'supervisión_facturación': {
      'dashboard_cajas': {
        'activo': 'importación/supervisión_facturación/dashboard_cajas',
      },
      'previos': {
        'activo': 'importación/supervisión_facturación/previos',
      },
      'disp_de_docs': {
        'activo': 'importación/supervisión_facturación/disp_de_docs',
      },
      'facturas_sin_cobrar': {
        'activo': 'importación/supervisión_facturación/dashboard_facturas_sin_cobrar',
      },
      'alta_desco': {
        'activo': 'importación/supervisión_facturación/alta_desco',
      },
      'facturación_administrativa': {
        'activo': 'importación/supervisión_facturación/facturación_administrativa',
      },
      'batch_facturación': {
        'activo': 'importación/supervisión_facturación/batch_facturación',
      },
      'batch_cancelación': {
        'activo': 'importación/supervisión_facturación/batch_cancelación',
      },
      'cancelación_02_03': {
        'activo': 'importación/supervisión_facturación/cancelación_02_03',
      }
    },
    'almacén': {
      'previos': {
        'activo': 'importación/almacén/previos',
      }
    },
    'salidas': {
      'activo': 'importación/salidas',
    },
    'reingresos': {
      'activo': 'importación/reingresos',
    },
    'incidencias': {
      'incidencias_operativas': {
        'activo': 'importación/incidencias/incidencias_operativas',
      },
      'irregularidades_SAT': {
        'activo': 'importación/incidencias/irregularidades_SAT',
      },
      'upd_m_h': {
        'activo': 'importación/incidencias/upd_m_h',
      }
    },
    'puntos_tácticos': {
      'agregar_registro': {
        'activo': 'importación/puntos_tácticos/agregar_registro',
      },
      'consulta': {
        'activo': 'importación/puntos_tácticos/consulta',
      },
      'editar': {
        'activo': 'importación/puntos_tácticos/editar',
      },
    },
    'kardex': {
      'activo': 'importación/kardex',
    },
    'reportes_importación': {
      'check_in_vuelos': {
        'activo': 'importación/reportes_importación/check_in_vuelos',
      },
      'inventario_importación': {
        'activo': 'importación/reportes_importación/inventario_importación',
      },
      'confronta': {
        'entradas_importación': {
          'activo': 'importación/reportes_importación/confronta/entradas_importación',
        },
        'importación_mex': {
          'activo': 'importación/reportes_importación/confronta/importación_mex',
        },
        'vuelos_registrados': {
          'activo': 'importación/reportes_importación/confronta/vuelos_registrados',
        },
        'guías_en_vuelo': {
          'activo': 'importación/reportes_importación/confronta/guías_en_vuelo',
        },
        'aerovías_y_otros': {
          'activo': 'importación/reportes_importación/confronta/aerovías_y_otros',
        }
      },
      'captura_upd': {
        'upd_detalles': {
          'activo': 'importación/reportes_importación/captura_upd/upd_detalles',
        },
        'upd_por_tipo_y_usuario': {
          'activo': 'importación/reportes_importación/captura_upd/upd_por_tipo_y_usuario',
        },
        'upd_totales_por_usuario': {
          'activo': 'importación/reportes_importación/captura_upd/upd_totales_por_usuario',
        }
      },
      'cajas': {
        'kardex': {
          'activo': 'importación/reportes_importación/cajas/kardex',
        },
        'general': {
          'activo': 'importación/reportes_importación/cajas/general',
        },
        'tombola': {
          'activo': 'importación/reportes_importación/cajas/tombola',
        }
      },
      'facturación': {
        'productividad_facturación_por_usuario': {
          'activo': 'importación/reportes_importación/facturación/productividad_facturación_por_usuario',
        },
        'facturas_canceladas_por_usuario': {
          'activo': 'importación/reportes_importación/facturación/facturas_canceladas_por_usuario',
        },
        'facturas_por_horas_al_día': {
          'activo': 'importación/reportes_importación/facturación/facturas_por_horas_al_día',
        }
      },
      'tiempos_de_atención_en_previos': {
        'activo': 'importación/reportes_importación/tiempos_de_atención_en_previos',
      },
      'salidas': {
        'salidas_importación': {
          'activo': 'importación/reportes_importación/salidas/salidas_importación',
        },
        'tiempos_de_atención_de_salidas': {
          'activo': 'importación/reportes_importación/salidas/tiempos_de_atención_de_salidas',
        }
      },
      'anual': {
        'activo': 'importación/reportes_importación/anual',
      }
    }
  },
  'Conexiones': {
    'tránsitos': {
      'milestones': {
        'activo': 'conexiones/tránsitos/milestones',
      },
      'altas_tránsitos': {
        'activo': 'conexiones/tránsitos/altas_tránsitos',
      }
    },
    'incidencias': {
      'activo': 'conexiones/incidencias',
    },
    'kardex': {
      'activo': 'conexiones/kardex',
    },
    'reportes_tránsitos': {
      'inventario_tránsitos': {
        'activo': 'conexiones/reportes_tránsitos/inventario_tránsitos',
      },
      'histórico': {
        'activo': 'conexiones/reportes_tránsitos/histórico',
      },
      'almacenes_externos': {
        'activo': 'conexiones/reportes_tránsitos/almacenes_externos',
      },
      'tránsitos': {
        'activo': 'conexiones/reportes_tránsitos/tránsitos',
      }
    },
    'dashboard_de_tránsitos': {
      'kpis_tránsitos': {
        'activo': 'conexiones/dashboard_de_tránsitos/kpis_tránsitos'
      }
    }
  },
  'Camara_fria': {
    'cooler': {
      'vale_cooler': {
        'activo': 'cámara_fría/cooler/vale_cooler',
      },
      'tiempos_expo': {
        'activo': 'cámara_fría/cooler/tiempos_expo',
      },
      'tiempos_impo': {
        'activo': 'cámara_fría/cooler/tiempos_impo',
      },
      'carga_de_insumo': {
        'activo': 'cámara_fría/cooler/carga_de_insumo',
      }
    },
    'incidencias': {
      'activo': 'cámara_fría/incidencias',
    },
    'kárdex': {
      'activo': 'cámara_fría/actualización_de_locaciones',
    },
    'reportes_cooler': {
      'inventario_cooler': {
        'activo': 'cámara_fría/reportes_cooler/inventario_cooler',
      },
      'bitácora_de_cooler': {
        'activo': 'cámara_fría/reportes_cooler/bitácora_de_cooler',
      },
      'bitácora_de_cooler_guía': {
        'activo': 'cámara_fría/reportes_cooler/bitácora_de_cooler_guía',
      },
      'trazabilidad_temp_impo': {
        'activo': 'cámara_fría/reportes_cooler/trazabilidad_temp_impo',
      },
      'trazabilidad_temp_expo': {
        'activo': 'cámara_fría/reportes_cooler/trazabilidad_temp_expo',
      },
      'cooler_trazabilidad': {
        'activo': 'cámara_fría/reportes_cooler/cooler_trazabilidad'
      }
    },
    'dashboard_cooler': {
      'activo': 'cámara_fría/dashboard_cooler',
    }
  },
  'Exportacion': {
    'andén': {
      'entradas': {
        'activo': 'exportación/andén/entradas',
      },
      'auditor': {
        'activo': 'exportación/andén/auditor'
      },
      'aceptación': {
        'activo': 'exportación/andén/aceptación',
      }
    },
    'incidencias': {
      'incidencias_operativas': {
        'activo': 'exportación/incidencias/incidencias_operativas',
      },
    },
    'kárdex': {
      'activo': 'exportación/kárdex',
    },
    'reportes_exportación': {
      'inventario_exportación': {
        'activo': 'exportación/reportes_exportación/inventario_exportación',
      },
      'mostrador': {
        'entradas_exportación_por_guia_registrada': {
          'activo': 'exportación/reportes_exportación/mostrador/entradas_exportación_por_guia_registrada',
        },
        'product_expo': {
          'activo': 'exportación/reportes_exportación/mostrador/product_expo',
        },
        'cliente_0000': {
          'activo':'exportación/reportes_exportación/mostrador/cliente_0000',
        }
      },
      'cajas': {
        'kardex': {
          'activo': 'exportación/reportes_exportación/cajas/kardex',
        },
        'general': {
          'activo': 'exportación/reportes_exportación/cajas/general',
        },
        'tombola': {
          'activo': 'exportación/reportes_exportación/cajas/tombola'
        }
      },
      'facturación': {
        'facturas_canceladas_por_usuario': {
          'activo': 'exportación/reportes_exportación/facturación/facturas_canceladas_por_usuario',
        },
        'productividad_servicio_exportación': {
          'activo': 'exportación/reportes_exportación/facturación/productividad_servicio_exportación',
        },
        'facturas_por_horas_al_dia_usuario': {
          'activo': 'exportación/reportes_exportación/facturación/facturas_por_horas_al_dia_usuario',
        }
      },
      'andén': {
        'auditoría_de_peso_volumen': {
          'activo': 'exportación/reportes_exportación/andén/auditoría_de_peso_volumen',
        },
        'medición_por_báscula': {
          'activo': 'exportación/reportes_exportación/andén/medición_por_báscula',
        },
        'cubiscan_por_cliente_naturaleza_destino': {
          'activo': 'exportación/reportes_exportación/andén/cubiscan_por_cliente_naturaleza_destino',
        },
        'productividad_cubiscan': {
          'activo': 'exportación/reportes_exportación/andén/productividad_cubiscan',
        },
        'aceptación_exportación_origen_mex': {
          'activo': 'exportación/reportes_exportación/andén/aceptación_exportación_origen_mex',
        },
        'trazabilidad_por_guía_de_exportación': {
          'activo': 'exportación/reportes_exportación/andén/trazabilidad_por_guía_de_exportación',
        }
      },
      'despacho': {
        'guías_despachadas_exportación': {
          'activo': 'exportación/reportes_exportación/despacho/guías_despachadas_exportación',
        },
        'vuelos_exportación': {
          'activo': 'exportación/reportes_exportación/despacho/vuelos_exportación',
        },
        'rezagos': {
          'activo': 'exportación/reportes_exportación/despacho/rezagos',
        },
        'desistimientos': {
          'activo': 'exportación/reportes_exportación/despacho/desistimientos',
        },
        'productividad_despacho': {
          'activo': 'exportación/reportes_exportación/despacho/productividad_despacho',
        }
      },
      'anual': {
        'activo': 'exportación/reportes_exportación/anual',
      }
    },
    'mostrador': {
      'cobro_en_caja': {
        'activo': 'exportación/mostrador/cobro_en_caja',
      }
    }
  },
  'Almacen': {
    'cajas': {
      'caja_principal': {
        'activo': 'gestión_de_almacén/cajas/caja_principal',
      },
      'devoluciones': {
        'activo': 'gestión_de_almacén/cajas/devoluciones',
      },
      'tombola': {
        'activo': 'gestión_de_almacén/cajas/tombola',
      },
      'estado_de_cuenta': {
        'activo': 'gestión_de_almacén/cajas/estado_de_cuenta',
      },
      'validacion_de_transfer': {
        'activo': 'gestión_de_almacén/cajas/validacion_de_transfer',
      }
    },
    'reportes_de_ingresos': {
      'ALFI_financiero': {
        'ALFI_importación': {
          'activo': 'gestión_de_almacén/reportes_de_ingresos/ALFI_financiero/ALFI_importación',
        },
        'ALFI_exportación': {
          'activo': 'gestión_de_almacén/reportes_de_ingresos/ALFI_financiero/ALFI_exportación',
        }
      },
      'ingresos_por_concepto': {
        'ingresos_por_concepto_importación': {
          'activo': 'gestión_de_almacén/reportes_de_ingresos/ingresos_por_concepto/ingresos_por_concepto_importación',
        },
        'ingresos_por_concepto_exportación': {
          'activo': 'gestión_de_almacén/reportes_de_ingresos/ingresos_por_concepto/ingresos_por_concepto_exportación'
        },
        'ingresos_por_cliente_exportación': {
          'activo':'gestión_de_almacén/reportes_de_ingresos/ingresos_por_concepto/ingresos_por_cliente_exportación',
        },
        'anual_exportación': {
          'activo': 'gestión_de_almacén/reportes_de_ingresos/ingresos_por_concepto/anual_exportación',
        },
        'toneladas_totales_por_dia_exportación': {
          'activo': 'gestión_de_almacén/reportes_de_ingresos/ingresos_por_concepto/toneladas_totales_por_dia_exportación',
        }
      }
    },
    'reportes_operativos': {
      'ALFI_operativo': {
        'ALFI_importación': {
          'activo': 'gestión_de_almacén/reportes_operativos/ALFI_operativo/ALFI_importación',
        },
        'ALFI_exportación': {
          'activo': 'gestión_de_almacén/reportes_operativos/ALFI_operativo/ALFI_exportación',
        },
        'toneladas_mensuales': {
          'activo': 'gestión_de_almacén/reportes_operativos/ALFI_operativo/toneladas_mensuales',
        }
      },
      'incidencias': {
        'activo': 'gestión_de_almacén/reportes_operativos/incidencias',
      },
      'locaciones': {
        'activo': 'gestión_de_almacén/reportes_operativos/locaciones',
      }
    },
    'abandonos': {
      'listado': {
        'activo': 'gestión_de_almacén/abandonos/listado',
      },
      'acuses': {
        'activo': 'gestión_de_almacén/abandonos/acuses',
      },
      'previos': {
        'activo': 'gestión_de_almacén/abandonos/previos',
      },
      'clasificación_SAT': {
        'activo': 'gestión_de_almacén/abandonos/clasificación_SAT',
      },
      'salidas': {
        'activo': 'gestión_de_almacén/abandonos/salidas',
      },
      'cálculo_de_abandono': {
        'activo': 'gestión_de_almacén/abandonos/cálculo_de_abandono',
      }
    },
    'aduana_cumplimiento_aduanal': {
      'conectividad_SAT': {
        'activo': 'gestión_de_almacén/aduana_cumplimiento_aduanal/conectividad_SAT',
      },
      'puntos_tácticos': {
        'activo': 'gestión_de_almacén/aduana_cumplimiento_aduanal/puntos_tácticos',
      },
      'PAMAS': {
        'activo': 'gestión_de_almacén/aduana_cumplimiento_aduanal/PAMAS',
      },
      'valor_promedio': {
        'activo': 'gestión_de_almacén/aduana_cumplimiento_aduanal/valor_promedio',
      },
      'valor_aduana': {
        'activo': 'gestión_de_almacén/aduana_cumplimiento_aduanal/valor_aduana',
      },
      'estrados': {
        'activo': 'gestión_de_almacén/aduana_cumplimiento_aduanal/estrados',
      }
    },
    'tarifas': {
      'tarifario_importación': {
        'activo': 'gestión_de_almacén/tarifas/tarifario_importación',
      },
      'tarifario_exportación': {
        'activo': 'gestión_de_almacén/tarifas/tarifario_exportación',
      },
      'excepciones_importación': {
        'activo': 'gestión_de_almacén/tarifas/excepciones_importación',
      },
      'reglas_comerciales_importación': {
        'activo': 'gestión_de_almacén/tarifas/reglas_comerciales_importación',
      },
      'folios_0_eliminados': {
        'activo': 'gestión_de_almacén/tarifas/folios_0_eliminados',
      },
      'tipo_de_cambio': {
        'activo': 'gestión_de_almacén/tarifas/tipo_de_cambio',
      }
    },
    'control_sistemas': {
      'ventana_mantenimiento': {
        'activo': 'gestión_de_almacén/control_sistemas/ventana_mantenimiento',
      },
      'FTP_cubiscan': {
        'activo': 'gestión_de_almacén/control_sistemas/FTP_cubiscan',
      },
      'logs_oracle': {
        'activo': 'gestión_de_almacén/control_sistemas/logs_oracle',
      },
      'erros_logs': {
        'activo': 'gestión_de_almacén/control_sistemas/erros_logs',
      },
    },
    'notificaciones': {
      'servicios': {
        'activo': 'gestión_de_almacén/notificaciones/servicios',
      },
      'SLA': {
        'activo': 'gestión_de_almacén/notificaciones/SLA',
      }
    }
  },
  'Domestico': {
    'dashboard': {
      'activo': 'doméstico/dashboard',
    },
    'llegadas': {
      'vuelos': {
        'activo': 'doméstico/llegadas/vuelos',
      },
      'tiempos_plataforma': {
        'activo': 'doméstico/llegadas/tiempos_plataforma',
      },
      'tiempos_confronta': {
        'activo': 'doméstico/llegadas/tiempos_confronta',
      },
      'vale_cooler': {
        'activo': 'doméstico/llegadas/vale_cooler',
      }
    },
    'salidas': {
      'captura_master': {
        'activo': 'doméstico/salidas/captura_master',
      },
      'vale_cooler': {
        'activo': 'doméstico/salidas/vale_cooler',
      },
      'tiempos_armado': {
        'activo': 'doméstico/salidas/tiempos_armado',
      },
      'tiempos_plataforma': {
        'activo': 'doméstico/salidas/tiempos_plataforma',
      }
    },
    'catálogos': {
      'usuarios_cooler': {
        'activo': 'doméstico/catálogos/usuarios_cooler',
      }
    },
    'reportes': {
      'kardex': {
        'activo': 'doméstico/reportes/kardex',
      },
      'inventario': {
        'activo': 'doméstico/reportes/inventario',
      },
      'bitacora_cooler_guia': {
        'activo': 'doméstico/reportes/bitácora_cooler_por_guía',
      },
      'bitacora_cooler_general': {
        'activo': 'doméstico/reportes/bitácora_cooler_general',
      },
      'pharma_llegadas': {
        'activo': 'doméstico/reportes/pharma_llegadas',
      },
      'pharma_salidas': {
        'activo': 'doméstico/reportes/pharma_salidas',
      },
      'carga_insumo': {
        'activo': 'doméstico/reportes/carga_de_insumo',
      }
    }
  }
}